import { MESApiService } from "@dexteel/mesf-core";

export const getPourbackReasons = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[STEEL].[GetPourbackReasons]", []);
};
